import { useLocation } from "react-router-dom";
import { COMPANY } from "@/data/branches";

// Context-aware WhatsApp pre-fill by route — boosts reply quality on the
// business side because the rep instantly knows the visitor's intent.
function contextFor(path) {
  if (path === "/")                          return "your smart classroom solutions";
  if (path.includes("/digital-board"))       return "Digital Board pricing & specs";
  if (path.includes("/smart-board"))         return "Smart Board options";
  if (path.includes("/interactive-flat-panel")) return "Interactive Flat Panel details";
  if (path.includes("/smart-infovision-"))   return `the demo at your ${path.split("-").pop()} center`;
  if (path.includes("/studio-experience") || path.includes("/studio-setup") || path === "/studio") return "Teaching Studio setup";
  if (path.includes("/recommendation"))      return "AI product recommendation";
  if (path.includes("/quotation"))           return "a customized quotation";
  if (path.includes("/compare"))             return "board comparison & advice";
  if (path.includes("/demo-booking"))        return "the free teacher assessment demo";
  if (path.includes("/free-resources"))      return "the free PDF resources";
  if (path.startsWith("/blog/"))             return "the article I'm reading on your blog";
  if (path.startsWith("/coachings/"))        return "digital boards for coaching institutes";
  if (path.startsWith("/educators/"))        return "studio setup for educators";
  return "your smart classroom setup";
}

export default function FloatingActions() {
  const { pathname } = useLocation();

  // Canonical sales channel — always route to the official Smart Infovision
  // sales phone / WhatsApp so an accidentally changed admin setting can
  // never break the primary conversion CTA on the site.
  const wa  = COMPANY.sales_phone_digits;
  const tel = COMPANY.sales_phone;
  const msg = encodeURIComponent(`Hi Smart Infovision! I'm interested in ${contextFor(pathname)}. Please share more details.`);

  return (
    <div className="fixed right-4 bottom-24 md:bottom-24 z-30 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={`https://wa.me/${wa}?text=${msg}`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        className="si-pulse w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:scale-110 transition-transform"
        aria-label="WhatsApp"
      >
        <i className="fa-brands fa-whatsapp text-2xl" />
      </a>
      <a
        href={`tel:${tel}`}
        data-testid="floating-call"
        className="w-14 h-14 rounded-full bg-slate-900 text-white grid place-items-center shadow-lg hover:scale-110 transition-transform lg:hidden"
        aria-label="Call"
      >
        <i className="fa-solid fa-phone text-xl" />
      </a>
    </div>
  );
}
